import { signal } from '@angular/core';
import { AllWeekDays } from '../../features/calender-and-events/models';
import { ChipOption } from '../components';

export class WeekDaysService {
  days = signal<ChipOption[]>([
    { label: 'Mon', value: AllWeekDays.Mon, fullName: 'Monday' },
    { label: 'Tue', value: AllWeekDays.Tue, fullName: 'Tuesday' },
    { label: 'Wed', value: AllWeekDays.Wed, fullName: 'Wednesday' },
    { label: 'Thu', value: AllWeekDays.Thu, fullName: 'Thursday' },
    { label: 'Fri', value: AllWeekDays.Fri, fullName: 'Friday' },
    { label: 'Sat', value: AllWeekDays.Sat, fullName: 'Saturday' },
    { label: 'Sun', value: AllWeekDays.Sun, fullName: 'Sunday' },
  ]);

  getSelectedDaysValue(daysSelected: number[]) {
    return daysSelected.reduce((acc, current) => acc | current, 0);
  }

  getSelectedDaysArray(bitmask: number): number[] {
    return this.days()
      .map(day => day.value)
      .filter(value => (bitmask & value) !== 0);
  }
}
